import React from "react";
import { cn } from "@/lib/utils";

const LABELS = {
  CREADA: "Creada",
  EN_PREPARACION: "En preparación",
  PARCIALMENTE_PREPARADA: "Parcialmente preparada",
  LISTA: "Lista",
  PARCIALMENTE_ENTREGADA: "Parcialmente entregada",
  ENTREGADA: "Entregada",
  ENTREGA_PENDIENTE: "Entrega pendiente",
  COBRADA: "Cobrada",
  CANCELADA: "Cancelada",
  DEVUELTA: "Devuelta",
  // product
  PENDIENTE: "Pendiente",
  PREPARADO: "Preparado",
  ENTREGADO: "Entregado",
  CANCELADO: "Cancelado",
  DEVUELTO: "Devuelto",
  // reparto
  PENDIENTE_ASIGNACION: "Sin asignar",
  ASIGNADO: "Asignado",
  EN_CAMINO: "En camino",
  NO_ENTREGADO: "No entregado",
};

export default function OrderStateBadge({ state, className }) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-md px-2 py-1 text-[10px] font-bold uppercase tracking-wider",
        `state-${state}`,
        className
      )}
      data-testid={`state-badge-${state}`}
    >
      {LABELS[state] || state}
    </span>
  );
}

export { LABELS as STATE_LABELS };
